import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import { assetsDataManagerDiscoverEntryPoint } from '@jira/spa-apps__assets-data-manager-discover/src/AssetsDataManagerDiscover.entrypoint.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { assetsDataManagerDiscoverRoute } from '@jira/router-routes__assets-app-routes/src/assetsDataManagerDiscoverRoute.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
import type { Route } from '@atlassian/react-resource-router';

const assetsDataManagerDiscoverPageEntryPoint = createChromelessEntryPoint({
	main: assetsDataManagerDiscoverEntryPoint,
});

export const assetsDataManagerDiscoverRouteEntry: Route = createEntry(
	assetsDataManagerDiscoverRoute,
	() => ({
		group: 'assets',
		LayoutOverrideComponent: AssetsLayout,
		PageConfigContainerOverride: AssetsPageConfigContainer,
		skeleton: AssetsSpinner,
		perfMetricKey: 'assets-data-manager-discover',
		ufoName: 'assets-data-manager-discover',
		pageId: () => 'assets-data-manager-discover',
		resources: getAssetsAppResources(),
		forPaint: [LazyAssetsLayout],
		entryPoint() {
			return fg('sqa-2098-assets-platform-app-nav-upsells')
				? assetsDataManagerDiscoverPageEntryPoint
				: undefined;
		},
		// eslint-disable-next-line no-restricted-syntax
		component: fg('sqa-2098-assets-platform-app-nav-upsells') ? undefined : ErrorPagesNotFound,
		bifrost: {
			bifrostGroup: 'shell-only',
			bundling: {
				packageName:
					'@jira/router-routes__assets-app-entries/src/assetsDataManagerDiscoverRouteEntry.tsx',
				whichExportToUse: 'assetsDataManagerDiscoverRouteEntry',
			},
			enabled: true,
		},
	}),
);
